import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GetAccountNotificationSettingsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAccountNotificationSettingsQuery = {
  getAccountSettings: {
    __typename: "AccountSettings";
    notificationSettings: {
      __typename: "AccountNotificationSettings";
      essentialUpdates: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
      highlightUpdates: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
      offersAboveFloor: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
      offerUpdates: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
    } | null;
  };
};

export type PublicUserProfileQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
}>;

export type PublicUserProfileQuery = {
  getPublicAccountSettings: {
    __typename: "PublicAccountSettings";
    imported: boolean | null;
    accountId: string;
    displayName: string | null;
    bio: string | null;
    avatarUrl: string | null;
    website: string | null;
    verified: boolean | null;
    walletAddresses: Array<string> | null;
    displayAvatar: string | null;
    followerCount: number | null;
    followingCount: number | null;
    isFollowing: boolean | null;
    socials: {
      __typename: "PublicLinkedSocials";
      twitter: {
        __typename: "PublicLinkedTwitter";
        username: string;
        importedViaFarcaster: boolean | null;
        connected: boolean | null;
      } | null;
      email: { __typename: "PublicLinkedEmail"; address: string } | null;
      rodeo: { __typename: "Rodeo"; username: string } | null;
      farcaster: { __typename: "Farcaster"; username: string } | null;
    } | null;
    notificationSettings: {
      __typename: "AccountNotificationSettings";
      essentialUpdates: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
      highlightUpdates: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
      offersAboveFloor: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
      offerUpdates: {
        __typename: "NotificationSetting";
        email: boolean;
        push: boolean;
      } | null;
    } | null;
  };
};

export type GenerateTwitterAuthUrlMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GenerateTwitterAuthUrlMutation = { generateTwitterAuthURL: string };

export type VerifyTwitterConnectionMutationVariables = Types.Exact<{
  code: Types.Scalars["String"];
  state: Types.Scalars["String"];
}>;

export type VerifyTwitterConnectionMutation = {
  verifyTwitterConnection: string;
};

export type DisconnectTwitterMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type DisconnectTwitterMutation = { disconnectTwitter: boolean };

export type GetUploadUrlForContractUriMutationVariables = Types.Exact<{
  data: Types.GetUploadUrlForContractUriRequest;
}>;

export type GetUploadUrlForContractUriMutation = {
  getUploadUrlForContractUri: {
    __typename: "HostedMediaResource";
    id: string;
    type: Types.SupportedMediaType;
    metadata: {
      __typename: "HostedMediaResourceMetadata";
      type: Types.SupportedMediaType;
      mime: Types.SupportedMediaMime;
      url: string | null;
      publicUrl: string | null;
    } | null;
  };
};

export type UpdateAccountSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateAccountSettings;
}>;

export type UpdateAccountSettingsMutation = {
  updateAccountSettings: {
    __typename: "PublicAccountSettings";
    accountId: string;
    displayName: string | null;
    bio: string | null;
    avatarUrl: string | null;
    website: string | null;
    socials: {
      __typename: "PublicLinkedSocials";
      email: { __typename: "PublicLinkedEmail"; address: string } | null;
      rodeo: { __typename: "Rodeo"; username: string } | null;
    } | null;
  };
};

export type GetPublicCollectionByWalletAddressQueryVariables = Types.Exact<{
  cursor: Types.Maybe<Types.Scalars["String"]>;
  walletAddress: Types.Scalars["String"];
  hidden: Types.Maybe<Types.Scalars["Boolean"]>;
}>;

export type GetPublicCollectionByWalletAddressQuery = {
  getPublicCollectionsByWallet: {
    __typename: "CollectionsPaginated";
    collections: Array<{
      __typename: "Collection";
      id: string;
      onchainId: string;
      name: string;
      type: Types.CollectionContractType;
      collectionType: Types._CollectionType;
      chainId: number;
      contractId: string | null;
      status: Types.CollectionStatus;
      baseUri: string | null;
      description: string | null;
      address: string;
      size: number | null;
      standard: Types.NftContractStandard | null;
      seriesDetails: {
        __typename: "SeriesDetails";
        coverImage: number;
        logoUrl: string | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetails";
        logoUrl: string | null;
      } | null;
      importData: { __typename: "ImportData"; logoUrl: string | null } | null;
      editions: Array<{
        __typename: "EditionToken";
        name: string;
        description: string;
        image: string;
        size: number;
        onChainImage: string;
        animation: string | null;
      }> | null;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
      totalCount: number;
    };
  };
};

export type GetCollectedByUserAddressQueryVariables = Types.Exact<{
  cursor: Types.Maybe<Types.Scalars["String"]>;
  walletAddress: Types.Scalars["String"];
}>;

export type GetCollectedByUserAddressQuery = {
  getCollectedByWalletAddress: {
    __typename: "NftsCollected";
    items: Array<{
      __typename: "NftCollected";
      id: string;
      collectionId: string | null;
      creatorId: string | null;
      collectionType: Types._CollectionType | null;
      address: string;
      animationUrl: string | null;
      description: string | null;
      imageUrl: string | null;
      name: string | null;
      tokenId: string | null;
      collectionName: string | null;
      creator: {
        __typename: "PublicAccountSettings";
        id: string | null;
        accountId: string;
        displayAvatar: string | null;
        displayName: string | null;
        walletAddresses: Array<string> | null;
        verified: boolean | null;
      } | null;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
    };
  };
};

export type LinkFarcasterMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type LinkFarcasterMutation = {
  linkFarcaster: { __typename: "Farcaster"; username: string };
};

export type UnlinkFarcasterMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UnlinkFarcasterMutation = {
  unlinkFarcaster: { __typename: "Farcaster"; username: string };
};

export type LinkEmailMutationVariables = Types.Exact<{ [key: string]: never }>;

export type LinkEmailMutation = { linkEmailFromProvider: string };

export type UnlinkEmailMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UnlinkEmailMutation = { unlinkEmailFromProvider: boolean };

export const GetAccountNotificationSettingsDocument = gql`
  query GetAccountNotificationSettings {
    getAccountSettings {
      notificationSettings {
        essentialUpdates {
          email
          push
        }
        highlightUpdates {
          email
          push
        }
        offersAboveFloor {
          email
          push
        }
        offerUpdates {
          email
          push
        }
      }
    }
  }
`;

/**
 * __useGetAccountNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetAccountNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountNotificationSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountNotificationSettingsQuery,
    GetAccountNotificationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountNotificationSettingsQuery,
    GetAccountNotificationSettingsQueryVariables
  >(GetAccountNotificationSettingsDocument, options);
}
export function useGetAccountNotificationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountNotificationSettingsQuery,
    GetAccountNotificationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountNotificationSettingsQuery,
    GetAccountNotificationSettingsQueryVariables
  >(GetAccountNotificationSettingsDocument, options);
}
export type GetAccountNotificationSettingsQueryHookResult = ReturnType<
  typeof useGetAccountNotificationSettingsQuery
>;
export type GetAccountNotificationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetAccountNotificationSettingsLazyQuery
>;
export type GetAccountNotificationSettingsQueryResult = Apollo.QueryResult<
  GetAccountNotificationSettingsQuery,
  GetAccountNotificationSettingsQueryVariables
>;
export const PublicUserProfileDocument = gql`
  query PublicUserProfile($slug: String!) {
    getPublicAccountSettings(slug: $slug) {
      imported
      accountId
      socials {
        twitter {
          username
          importedViaFarcaster
          connected
        }
        email {
          address
        }
        rodeo {
          username
        }
        farcaster {
          username
        }
      }
      displayName
      bio
      avatarUrl
      website
      verified
      walletAddresses
      displayAvatar
      notificationSettings {
        essentialUpdates {
          email
          push
        }
        highlightUpdates {
          email
          push
        }
        offersAboveFloor {
          email
          push
        }
        offerUpdates {
          email
          push
        }
      }
      followerCount
      followingCount
      isFollowing
    }
  }
`;

/**
 * __usePublicUserProfileQuery__
 *
 * To run a query within a React component, call `usePublicUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserProfileQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicUserProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublicUserProfileQuery,
    PublicUserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PublicUserProfileQuery,
    PublicUserProfileQueryVariables
  >(PublicUserProfileDocument, options);
}
export function usePublicUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicUserProfileQuery,
    PublicUserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PublicUserProfileQuery,
    PublicUserProfileQueryVariables
  >(PublicUserProfileDocument, options);
}
export type PublicUserProfileQueryHookResult = ReturnType<
  typeof usePublicUserProfileQuery
>;
export type PublicUserProfileLazyQueryHookResult = ReturnType<
  typeof usePublicUserProfileLazyQuery
>;
export type PublicUserProfileQueryResult = Apollo.QueryResult<
  PublicUserProfileQuery,
  PublicUserProfileQueryVariables
>;
export const GenerateTwitterAuthUrlDocument = gql`
  mutation GenerateTwitterAuthURL {
    generateTwitterAuthURL
  }
`;
export type GenerateTwitterAuthUrlMutationFn = Apollo.MutationFunction<
  GenerateTwitterAuthUrlMutation,
  GenerateTwitterAuthUrlMutationVariables
>;

/**
 * __useGenerateTwitterAuthUrlMutation__
 *
 * To run a mutation, you first call `useGenerateTwitterAuthUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTwitterAuthUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTwitterAuthUrlMutation, { data, loading, error }] = useGenerateTwitterAuthUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateTwitterAuthUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateTwitterAuthUrlMutation,
    GenerateTwitterAuthUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateTwitterAuthUrlMutation,
    GenerateTwitterAuthUrlMutationVariables
  >(GenerateTwitterAuthUrlDocument, options);
}
export type GenerateTwitterAuthUrlMutationHookResult = ReturnType<
  typeof useGenerateTwitterAuthUrlMutation
>;
export type GenerateTwitterAuthUrlMutationResult =
  Apollo.MutationResult<GenerateTwitterAuthUrlMutation>;
export type GenerateTwitterAuthUrlMutationOptions = Apollo.BaseMutationOptions<
  GenerateTwitterAuthUrlMutation,
  GenerateTwitterAuthUrlMutationVariables
>;
export const VerifyTwitterConnectionDocument = gql`
  mutation VerifyTwitterConnection($code: String!, $state: String!) {
    verifyTwitterConnection(code: $code, state: $state)
  }
`;
export type VerifyTwitterConnectionMutationFn = Apollo.MutationFunction<
  VerifyTwitterConnectionMutation,
  VerifyTwitterConnectionMutationVariables
>;

/**
 * __useVerifyTwitterConnectionMutation__
 *
 * To run a mutation, you first call `useVerifyTwitterConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwitterConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwitterConnectionMutation, { data, loading, error }] = useVerifyTwitterConnectionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useVerifyTwitterConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyTwitterConnectionMutation,
    VerifyTwitterConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyTwitterConnectionMutation,
    VerifyTwitterConnectionMutationVariables
  >(VerifyTwitterConnectionDocument, options);
}
export type VerifyTwitterConnectionMutationHookResult = ReturnType<
  typeof useVerifyTwitterConnectionMutation
>;
export type VerifyTwitterConnectionMutationResult =
  Apollo.MutationResult<VerifyTwitterConnectionMutation>;
export type VerifyTwitterConnectionMutationOptions = Apollo.BaseMutationOptions<
  VerifyTwitterConnectionMutation,
  VerifyTwitterConnectionMutationVariables
>;
export const DisconnectTwitterDocument = gql`
  mutation DisconnectTwitter {
    disconnectTwitter
  }
`;
export type DisconnectTwitterMutationFn = Apollo.MutationFunction<
  DisconnectTwitterMutation,
  DisconnectTwitterMutationVariables
>;

/**
 * __useDisconnectTwitterMutation__
 *
 * To run a mutation, you first call `useDisconnectTwitterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectTwitterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectTwitterMutation, { data, loading, error }] = useDisconnectTwitterMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectTwitterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisconnectTwitterMutation,
    DisconnectTwitterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisconnectTwitterMutation,
    DisconnectTwitterMutationVariables
  >(DisconnectTwitterDocument, options);
}
export type DisconnectTwitterMutationHookResult = ReturnType<
  typeof useDisconnectTwitterMutation
>;
export type DisconnectTwitterMutationResult =
  Apollo.MutationResult<DisconnectTwitterMutation>;
export type DisconnectTwitterMutationOptions = Apollo.BaseMutationOptions<
  DisconnectTwitterMutation,
  DisconnectTwitterMutationVariables
>;
export const GetUploadUrlForContractUriDocument = gql`
  mutation GetUploadUrlForContractUri(
    $data: GetUploadUrlForContractUriRequest!
  ) {
    getUploadUrlForContractUri(data: $data) {
      id
      type
      metadata {
        type
        mime
        url
        publicUrl
      }
    }
  }
`;
export type GetUploadUrlForContractUriMutationFn = Apollo.MutationFunction<
  GetUploadUrlForContractUriMutation,
  GetUploadUrlForContractUriMutationVariables
>;

/**
 * __useGetUploadUrlForContractUriMutation__
 *
 * To run a mutation, you first call `useGetUploadUrlForContractUriMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlForContractUriMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUploadUrlForContractUriMutation, { data, loading, error }] = useGetUploadUrlForContractUriMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUploadUrlForContractUriMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetUploadUrlForContractUriMutation,
    GetUploadUrlForContractUriMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetUploadUrlForContractUriMutation,
    GetUploadUrlForContractUriMutationVariables
  >(GetUploadUrlForContractUriDocument, options);
}
export type GetUploadUrlForContractUriMutationHookResult = ReturnType<
  typeof useGetUploadUrlForContractUriMutation
>;
export type GetUploadUrlForContractUriMutationResult =
  Apollo.MutationResult<GetUploadUrlForContractUriMutation>;
export type GetUploadUrlForContractUriMutationOptions =
  Apollo.BaseMutationOptions<
    GetUploadUrlForContractUriMutation,
    GetUploadUrlForContractUriMutationVariables
  >;
export const UpdateAccountSettingsDocument = gql`
  mutation UpdateAccountSettings($input: UpdateAccountSettings!) {
    updateAccountSettings(input: $input) {
      accountId
      displayName
      bio
      avatarUrl
      website
      socials {
        email {
          address
        }
        rodeo {
          username
        }
      }
    }
  }
`;
export type UpdateAccountSettingsMutationFn = Apollo.MutationFunction<
  UpdateAccountSettingsMutation,
  UpdateAccountSettingsMutationVariables
>;

/**
 * __useUpdateAccountSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountSettingsMutation, { data, loading, error }] = useUpdateAccountSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccountSettingsMutation,
    UpdateAccountSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccountSettingsMutation,
    UpdateAccountSettingsMutationVariables
  >(UpdateAccountSettingsDocument, options);
}
export type UpdateAccountSettingsMutationHookResult = ReturnType<
  typeof useUpdateAccountSettingsMutation
>;
export type UpdateAccountSettingsMutationResult =
  Apollo.MutationResult<UpdateAccountSettingsMutation>;
export type UpdateAccountSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountSettingsMutation,
  UpdateAccountSettingsMutationVariables
>;
export const GetPublicCollectionByWalletAddressDocument = gql`
  query GetPublicCollectionByWalletAddress(
    $cursor: String
    $walletAddress: String!
    $hidden: Boolean
  ) {
    getPublicCollectionsByWallet(
      cursor: $cursor
      walletAddress: $walletAddress
      hidden: $hidden
    ) {
      collections {
        id
        onchainId
        name
        type
        collectionType
        chainId
        contractId
        status
        baseUri
        description
        address
        size
        standard
        seriesDetails {
          coverImage
          logoUrl
        }
        generativeDetails {
          logoUrl
        }
        importData {
          logoUrl
        }
        editions {
          name
          description
          image
          size
          onChainImage
          animation
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetPublicCollectionByWalletAddressQuery__
 *
 * To run a query within a React component, call `useGetPublicCollectionByWalletAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCollectionByWalletAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCollectionByWalletAddressQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      walletAddress: // value for 'walletAddress'
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useGetPublicCollectionByWalletAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicCollectionByWalletAddressQuery,
    GetPublicCollectionByWalletAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPublicCollectionByWalletAddressQuery,
    GetPublicCollectionByWalletAddressQueryVariables
  >(GetPublicCollectionByWalletAddressDocument, options);
}
export function useGetPublicCollectionByWalletAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicCollectionByWalletAddressQuery,
    GetPublicCollectionByWalletAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublicCollectionByWalletAddressQuery,
    GetPublicCollectionByWalletAddressQueryVariables
  >(GetPublicCollectionByWalletAddressDocument, options);
}
export type GetPublicCollectionByWalletAddressQueryHookResult = ReturnType<
  typeof useGetPublicCollectionByWalletAddressQuery
>;
export type GetPublicCollectionByWalletAddressLazyQueryHookResult = ReturnType<
  typeof useGetPublicCollectionByWalletAddressLazyQuery
>;
export type GetPublicCollectionByWalletAddressQueryResult = Apollo.QueryResult<
  GetPublicCollectionByWalletAddressQuery,
  GetPublicCollectionByWalletAddressQueryVariables
>;
export const GetCollectedByUserAddressDocument = gql`
  query GetCollectedByUserAddress($cursor: String, $walletAddress: String!) {
    getCollectedByWalletAddress(
      cursor: $cursor
      walletAddress: $walletAddress
    ) {
      items {
        id
        collectionId
        creatorId
        collectionType
        creator {
          id
          accountId
          displayAvatar
          displayName
          walletAddresses
          displayAvatar
          verified
        }
        address
        animationUrl
        description
        imageUrl
        name
        tokenId
        collectionName
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useGetCollectedByUserAddressQuery__
 *
 * To run a query within a React component, call `useGetCollectedByUserAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectedByUserAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectedByUserAddressQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      walletAddress: // value for 'walletAddress'
 *   },
 * });
 */
export function useGetCollectedByUserAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectedByUserAddressQuery,
    GetCollectedByUserAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectedByUserAddressQuery,
    GetCollectedByUserAddressQueryVariables
  >(GetCollectedByUserAddressDocument, options);
}
export function useGetCollectedByUserAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectedByUserAddressQuery,
    GetCollectedByUserAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectedByUserAddressQuery,
    GetCollectedByUserAddressQueryVariables
  >(GetCollectedByUserAddressDocument, options);
}
export type GetCollectedByUserAddressQueryHookResult = ReturnType<
  typeof useGetCollectedByUserAddressQuery
>;
export type GetCollectedByUserAddressLazyQueryHookResult = ReturnType<
  typeof useGetCollectedByUserAddressLazyQuery
>;
export type GetCollectedByUserAddressQueryResult = Apollo.QueryResult<
  GetCollectedByUserAddressQuery,
  GetCollectedByUserAddressQueryVariables
>;
export const LinkFarcasterDocument = gql`
  mutation LinkFarcaster {
    linkFarcaster {
      username
    }
  }
`;
export type LinkFarcasterMutationFn = Apollo.MutationFunction<
  LinkFarcasterMutation,
  LinkFarcasterMutationVariables
>;

/**
 * __useLinkFarcasterMutation__
 *
 * To run a mutation, you first call `useLinkFarcasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkFarcasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkFarcasterMutation, { data, loading, error }] = useLinkFarcasterMutation({
 *   variables: {
 *   },
 * });
 */
export function useLinkFarcasterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkFarcasterMutation,
    LinkFarcasterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LinkFarcasterMutation,
    LinkFarcasterMutationVariables
  >(LinkFarcasterDocument, options);
}
export type LinkFarcasterMutationHookResult = ReturnType<
  typeof useLinkFarcasterMutation
>;
export type LinkFarcasterMutationResult =
  Apollo.MutationResult<LinkFarcasterMutation>;
export type LinkFarcasterMutationOptions = Apollo.BaseMutationOptions<
  LinkFarcasterMutation,
  LinkFarcasterMutationVariables
>;
export const UnlinkFarcasterDocument = gql`
  mutation UnlinkFarcaster {
    unlinkFarcaster {
      username
    }
  }
`;
export type UnlinkFarcasterMutationFn = Apollo.MutationFunction<
  UnlinkFarcasterMutation,
  UnlinkFarcasterMutationVariables
>;

/**
 * __useUnlinkFarcasterMutation__
 *
 * To run a mutation, you first call `useUnlinkFarcasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFarcasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFarcasterMutation, { data, loading, error }] = useUnlinkFarcasterMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlinkFarcasterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlinkFarcasterMutation,
    UnlinkFarcasterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnlinkFarcasterMutation,
    UnlinkFarcasterMutationVariables
  >(UnlinkFarcasterDocument, options);
}
export type UnlinkFarcasterMutationHookResult = ReturnType<
  typeof useUnlinkFarcasterMutation
>;
export type UnlinkFarcasterMutationResult =
  Apollo.MutationResult<UnlinkFarcasterMutation>;
export type UnlinkFarcasterMutationOptions = Apollo.BaseMutationOptions<
  UnlinkFarcasterMutation,
  UnlinkFarcasterMutationVariables
>;
export const LinkEmailDocument = gql`
  mutation LinkEmail {
    linkEmailFromProvider
  }
`;
export type LinkEmailMutationFn = Apollo.MutationFunction<
  LinkEmailMutation,
  LinkEmailMutationVariables
>;

/**
 * __useLinkEmailMutation__
 *
 * To run a mutation, you first call `useLinkEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEmailMutation, { data, loading, error }] = useLinkEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useLinkEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkEmailMutation,
    LinkEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LinkEmailMutation, LinkEmailMutationVariables>(
    LinkEmailDocument,
    options
  );
}
export type LinkEmailMutationHookResult = ReturnType<
  typeof useLinkEmailMutation
>;
export type LinkEmailMutationResult = Apollo.MutationResult<LinkEmailMutation>;
export type LinkEmailMutationOptions = Apollo.BaseMutationOptions<
  LinkEmailMutation,
  LinkEmailMutationVariables
>;
export const UnlinkEmailDocument = gql`
  mutation UnlinkEmail {
    unlinkEmailFromProvider
  }
`;
export type UnlinkEmailMutationFn = Apollo.MutationFunction<
  UnlinkEmailMutation,
  UnlinkEmailMutationVariables
>;

/**
 * __useUnlinkEmailMutation__
 *
 * To run a mutation, you first call `useUnlinkEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEmailMutation, { data, loading, error }] = useUnlinkEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlinkEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlinkEmailMutation,
    UnlinkEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnlinkEmailMutation, UnlinkEmailMutationVariables>(
    UnlinkEmailDocument,
    options
  );
}
export type UnlinkEmailMutationHookResult = ReturnType<
  typeof useUnlinkEmailMutation
>;
export type UnlinkEmailMutationResult =
  Apollo.MutationResult<UnlinkEmailMutation>;
export type UnlinkEmailMutationOptions = Apollo.BaseMutationOptions<
  UnlinkEmailMutation,
  UnlinkEmailMutationVariables
>;
